export interface Withdrawal {
  id: number;
  amount: string;
  status: "pending" | "approved" | "rejected" | "transferred";
  statusLabel: string;
  bankName: string;
  iban: string;
  accountName: string;
  date: string;
  ref?: string;
}

export const withdrawals: Withdrawal[] = [
  {
    id: 1,
    amount: "3,570",
    status: "transferred",
    statusLabel: "تم التحويل ✓",
    bankName: "مصرف الراجحي",
    iban: "SA44 2000 0001 2345 6789 1234",
    accountName: "شركة الماية للخدمات",
    date: "3 أغسطس 2026",
    ref: "REF-88412",
  },
  {
    id: 2,
    amount: "3,130",
    status: "transferred",
    statusLabel: "تم التحويل ✓",
    bankName: "مصرف الراجحي",
    iban: "SA44 2000 0001 2345 6789 1234",
    accountName: "شركة الماية للخدمات",
    date: "19 يوليو 2026",
    ref: "REF-85671",
  },
  {
    id: 3,
    amount: "2,800",
    status: "pending",
    statusLabel: "قيد المراجعة",
    bankName: "مصرف الراجحي",
    iban: "SA44 2000 0001 2345 6789 1234",
    accountName: "شركة الماية للخدمات",
    date: "14 أغسطس 2026",
  },
];